/* unplugin-vue-components disabled */import script from "./SelectTaxpayerPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectTaxpayerPopup.vue?vue&type=script&setup=true&lang=js"

import "./SelectTaxpayerPopup.vue?vue&type=style&index=0&id=59361d3a&lang=scss"

const __exports__ = script;

export default __exports__